import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
	listItem: {
		cursor: "pointer",
		alignContent: "center",
		paddingTop: "0px",
		paddingBottom: "0px",
		"& $listItemIcon": {
			width: 24,
			height: 24,
			color: "#fff",
			zoom: "100%"
		},
		"& svg": {
			display: "block",
			transform: "translateX(30%)"
		}
	},
	activeListItem: {
		background: "rgba(181, 199, 97, 0.5)"
	},
	listItemText: {
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "15px",
		lineHeight: "32px",
		color: "#2c2c2c",
		paddingTop: "0px",
		paddingBottom: "0px"
	},
	listItemIcon: {
		marginRight: 0,
		paddingTop: "0px",
		paddingBottom: "0px"
	}
}));
